import { PxApiError } from './PxApiError';
import { LoggerTexts } from '../LoggerTexts';

export class InitControllerError extends PxApiError {
	_initialError?: Error;
	constructor(initialError?: Error, message?: string) {
		const formattedMessage = message ? message.trim() : '';
		/* istanbul ignore next */ //Coverage works correctly with ES6
		super(formattedMessage);

		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, InitControllerError);
		}
		this.name = 'PxApi.InitControllerError';
		this._initialError = initialError;

		let messageText = LoggerTexts.INIT_CONTROLLER.ERROR_HEADER;
		if (formattedMessage) {
			messageText += ` ${formattedMessage}`;
		}
		this.message = messageText;
	}
}
